import React from 'react';
import { PlusIcon, PlayIcon, PauseIcon, CopyIcon, EditIcon, TrashIcon } from 'lucide-react';
export function IntegrationsWebhooksTab() {
  const webhooks = [{
    id: 1,
    name: 'Account Created',
    url: 'https://api.company.com/webhooks/account-created',
    events: ['account.created', 'account.updated'],
    status: 'active',
    lastTriggered: '5 minutes ago',
    successRate: 99.8,
    avgLatency: 120
  }, {
    id: 2,
    name: 'Opportunity Won',
    url: 'https://api.company.com/webhooks/opp-won',
    events: ['opportunity.won'],
    status: 'active',
    lastTriggered: '2 hours ago',
    successRate: 100,
    avgLatency: 85
  }, {
    id: 3,
    name: 'Lead Status Change',
    url: 'https://api.company.com/webhooks/lead-status',
    events: ['lead.status_changed'],
    status: 'paused',
    lastTriggered: '1 day ago',
    successRate: 98.5,
    avgLatency: 150
  }];
  const eventTypes = [{
    id: 'account.created',
    name: 'Account Created',
    category: 'Accounts'
  }, {
    id: 'account.updated',
    name: 'Account Updated',
    category: 'Accounts'
  }, {
    id: 'account.deleted',
    name: 'Account Deleted',
    category: 'Accounts'
  }, {
    id: 'contact.created',
    name: 'Contact Created',
    category: 'Contacts'
  }, {
    id: 'contact.updated',
    name: 'Contact Updated',
    category: 'Contacts'
  }, {
    id: 'opportunity.created',
    name: 'Opportunity Created',
    category: 'Opportunities'
  }, {
    id: 'opportunity.updated',
    name: 'Opportunity Updated',
    category: 'Opportunities'
  }, {
    id: 'opportunity.won',
    name: 'Opportunity Won',
    category: 'Opportunities'
  }, {
    id: 'opportunity.lost',
    name: 'Opportunity Lost',
    category: 'Opportunities'
  }, {
    id: 'lead.status_changed',
    name: 'Lead Status Changed',
    category: 'Leads'
  }];
  const recentDeliveries = [{
    id: 1,
    webhook: 'Account Created',
    event: 'account.created',
    timestamp: '2024-01-20 14:55',
    status: 'success',
    statusCode: 200,
    latency: 115
  }, {
    id: 2,
    webhook: 'Account Created',
    event: 'account.updated',
    timestamp: '2024-01-20 14:50',
    status: 'success',
    statusCode: 200,
    latency: 125
  }, {
    id: 3,
    webhook: 'Opportunity Won',
    event: 'opportunity.won',
    timestamp: '2024-01-20 12:30',
    status: 'success',
    statusCode: 200,
    latency: 85
  }, {
    id: 4,
    webhook: 'Lead Status Change',
    event: 'lead.status_changed',
    timestamp: '2024-01-19 16:45',
    status: 'failed',
    statusCode: 500,
    latency: 0
  }];
  return <div className="space-y-6" data-id="element-1897">
      {/* Summary Cards */}
      <div className="grid grid-cols-4 gap-4" data-id="element-1898">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1899">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1900">Active Webhooks</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1901">2</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1902">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1903">Events Today</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1904">342</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1905">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1906">Success Rate</p>
          <p className="text-3xl font-bold text-green-600" data-id="element-1907">99.7%</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1908">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1909">Avg Latency</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1910">118ms</p>
        </div>
      </div>
      {/* Webhooks Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1911">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1912">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1913">
            Webhook Endpoints
          </h3>
          <button className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-1914">
            <PlusIcon className="w-4 h-4" data-id="element-1915" />
            Create Webhook
          </button>
        </div>
        <table className="w-full" data-id="element-1916">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1917">
            <tr data-id="element-1918">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1919">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1920">
                URL
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1921">
                Events
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1922">
                Last Triggered
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1923">
                Success Rate
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1924">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1925">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1926">
            {webhooks.map(webhook => <tr key={webhook.id} className="hover:bg-gray-50" data-id="element-1927">
                <td className="px-6 py-4" data-id="element-1928">
                  <span className="text-sm font-medium text-gray-900" data-id="element-1929">
                    {webhook.name}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1930">
                  <div className="flex items-center gap-2" data-id="element-1931">
                    <span className="text-sm text-gray-700 font-mono truncate max-w-xs" data-id="element-1932">
                      {webhook.url}
                    </span>
                    <button className="p-1 hover:bg-gray-100 rounded" data-id="element-1933">
                      <CopyIcon className="w-4 h-4 text-gray-400" data-id="element-1934" />
                    </button>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-1935">
                  <div className="flex flex-wrap gap-1" data-id="element-1936">
                    {webhook.events.map(event => <span key={event} className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-1937">
                        {event}
                      </span>)}
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-1938">
                  <span className="text-sm text-gray-700" data-id="element-1939">
                    {webhook.lastTriggered}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1940">
                  <span className="text-sm font-medium text-green-600" data-id="element-1941">
                    {webhook.successRate}%
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1942">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${webhook.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-1943">
                    {webhook.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1944">
                  <div className="flex items-center gap-2" data-id="element-1945">
                    {webhook.status === 'active' ? <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" data-id="element-1946">
                        <PauseIcon className="w-4 h-4 text-gray-600" data-id="element-1947" />
                      </button> : <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" data-id="element-1948">
                        <PlayIcon className="w-4 h-4 text-gray-600" data-id="element-1949" />
                      </button>}
                    <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" data-id="element-1950">
                      <EditIcon className="w-4 h-4 text-gray-600" data-id="element-1951" />
                    </button>
                    <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" data-id="element-1952">
                      <TrashIcon className="w-4 h-4 text-red-600" data-id="element-1953" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Available Events */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-1954">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-1955">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1956">
            Available Event Types
          </h3>
          <p className="text-sm text-gray-600 mt-1" data-id="element-1957">
            Subscribe to these events in your webhooks
          </p>
        </div>
        <div className="p-6" data-id="element-1958">
          <div className="grid grid-cols-3 gap-4" data-id="element-1959">
            {eventTypes.map(event => <div key={event.id} className="p-3 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1960">
                <p className="text-xs text-gray-600 mb-1" data-id="element-1961">{event.category}</p>
                <p className="text-sm font-medium text-gray-900" data-id="element-1962">
                  {event.name}
                </p>
                <p className="text-xs text-gray-500 font-mono mt-1" data-id="element-1963">
                  {event.id}
                </p>
              </div>)}
          </div>
        </div>
      </div>
      {/* Recent Deliveries */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1964">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-1965">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1966">
            Recent Deliveries
          </h3>
        </div>
        <table className="w-full" data-id="element-1967">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1968">
            <tr data-id="element-1969">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1970">
                Webhook
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1971">
                Event
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1972">
                Timestamp
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1973">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1974">
                Status Code
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1975">
                Latency
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1976">
            {recentDeliveries.map(delivery => <tr key={delivery.id} className="hover:bg-gray-50" data-id="element-1977">
                <td className="px-6 py-4" data-id="element-1978">
                  <span className="text-sm font-medium text-gray-900" data-id="element-1979">
                    {delivery.webhook}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1980">
                  <span className="text-sm text-gray-700 font-mono" data-id="element-1981">
                    {delivery.event}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1982">
                  <span className="text-sm text-gray-700" data-id="element-1983">
                    {delivery.timestamp}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1984">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${delivery.status === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`} data-id="element-1985">
                    {delivery.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1986">
                  <span className={`text-sm font-medium ${delivery.statusCode === 200 ? 'text-green-600' : 'text-red-600'}`} data-id="element-1987">
                    {delivery.statusCode}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1988">
                  <span className="text-sm text-gray-900" data-id="element-1989">
                    {delivery.latency}ms
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}